import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Card, Accordion, Form, InputGroup } from "react-bootstrap";

import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import { CHANGE_RENT_FUND } from "../../../actions/create-bot-type";
import { isLong } from "../../../utils/Utils";
import { formatNumberToString } from "../../../utils/Utils";

const TradeParamsViewRent = (props) => {
  const {  editing,rental,t } = props;
  const rentBot = useSelector((state) => state.createBot.rentBot);
  const fund = rentBot.initFund;
  const currentCoin = isLong(editing?rentBot.strategy:rental.template.strategy)
    ? rentBot.quoteCoin
    : rentBot.baseCoin;
  const balances = useSelector((state) => state.bots.balances);
  const balance =
    balances && balances.find((item) => item.coin === currentCoin);
  const pairData = useSelector((state) => state.bots.pairData);
  const pairMarginLevels = rentBot.pairMarginLevels;
  const [marginLevel,setMarginLevel] = useState(pairMarginLevels && pairMarginLevels[0]? pairMarginLevels[0].percentage:0 || 0)
  const dispatch = useDispatch();
  useEffect(() => {
    if (balance && !editing) {
      fundChanged(balance.free);
    }
  }, [balance]);

  const fundChanged = (val) => {
    dispatch({
      type: CHANGE_RENT_FUND,
      payload: val,
    });
    if(pairMarginLevels){
      for (var i=0; i < pairMarginLevels.length;i++){
        var item = pairMarginLevels[i]
        if(val < item.quantity){
          setMarginLevel(i>0?pairMarginLevels[i-1].percentage:pairMarginLevels[i].percentage)
          break;
        }
        setMarginLevel(pairMarginLevels[i].percentage)
       //console.log("marginLevel",item)
      }
      
      
    }
  };

  return (
    <>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="1">
          2. {t("t-params")}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
          <Card.Body>
            <Form.Group>
              <Form.Label>
              {t("fund-alloc")} <TutorialPopup content={t("initFund-help")} />
              </Form.Label>
              
                <>
                  <InputGroup>
                    <Form.Control
                      as="input"
                      type="number"
                      placeholder="1000"
                      value={fund}
                      onChange={(e) => {
                        fundChanged(e.target.value);
                      }}
                    ></Form.Control>
                    <InputGroup.Append>
                      <InputGroup.Text>{currentCoin}</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                </>
                <p style={{ fontSize: 13, marginTop: 2 }}>Min Quantity : {rentBot.minQuantity}</p>
              <p style={{ fontSize: 13, marginTop: 10 }}>
              {t("Margin Required")}: {(fund * marginLevel)/100} {" "}{pairData && pairData.funds && pairData.funds.coin} &nbsp;
                {t("available")}: {formatNumberToString(pairData && pairData.funds && pairData.funds.tradableFunds,2 )}{" "}  {pairData && pairData.funds && pairData.funds.coin}
              </p>
            </Form.Group>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export default connect(null)(TradeParamsViewRent);
